import { render, staticRenderFns } from "./DraftUpdateParticipantStatusComponent.vue?vue&type=template&id=5dd75de7&scoped=true&"
import script from "./DraftUpdateParticipantStatusComponent.vue?vue&type=script&lang=js&"
export * from "./DraftUpdateParticipantStatusComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd75de7",
  null
  
)

export default component.exports